import type { FC } from 'react';

import { ModalLoading } from 'Features/SellerCommunications/components/ModalLoading';
import { EnquiriesSelectStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

export const ProcessingEmails: FC = () => {
	const { selectedSaleIds } = EnquiriesSelectStore.getState();

	return (
		<ModalLoading
			description={T.translate(`processingEmails.description.${selectedSaleIds.length > 1 ? 'multiple' : 'single'}`, {
				count: selectedSaleIds.length,
			})}
			title={T.translate(`processingEmails.title.${selectedSaleIds.length > 1 ? 'multiple' : 'single'}`)}
		/>
	);
};
